import React, {useEffect, useState} from 'react';
import InputDatetime from "../../../../../components/input/input-datetime.jsx";
import Button from "../../../../../components/button/button.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";
import {FaTrash} from "react-icons/fa";
import projectUtils from "../../../../../utils/project-utils.js";

const JanitorialCreateTaskModal = ({open, setOpen, onConfirm}) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [closeModalError, setCloseModalError] = useState("");

    useEffect(() => {
        if (open) {
            setSelectedDate(null);
            setCloseModalError("");
        }
    }, [open]);

    const handleConfirm = () => {
        if (!selectedDate) {
            // setCloseModalError("O campo 'Data/hora para envio' é obrigatório.");
            projectUtils.swalErrorMessage("", "O campo \"Data/Hora\" é obrigatório.", "Ok");
            return;
        }

        onConfirm(selectedDate);
        setOpen(false);
        setSelectedDate(null);
        setCloseModalError("");
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedDate(null);
    };

    const handleClearDate = () => {
        setSelectedDate(null);
    };

    return (
        <>
            <style>{`
                .react-datepicker-popper {
                    z-index: 9999 !important;
                }
                [data-headlessui-state="open"] .transform {
                    overflow: visible !important;
                }
            `}</style>

            <Modal
                open={open}
                setOpen={handleClose}
                centered
                backdrop="static"
                keyboard={false}
                title={"Agendamento de tarefa (CAD)"}
                className={"w-4/12"}
                isCloseClick={false}
                showCloseButton={true}
            >
                <Modal.Body className={"p-4"}>
                    <div className="mb-4">
                        <div className="flex gap-2 items-end">
                            <div className="flex-1">
                                <InputDatetime
                                    id={"task_date"}
                                    label={"Data/hora *"}
                                    selected={selectedDate}
                                    dateFormat="LL"
                                    onChange={(date) => {
                                        setSelectedDate(date);
                                        if (closeModalError) setCloseModalError("");
                                    }}
                                    isClearable
                                    minDate={new Date()}
                                />
                            </div>
                        </div>
                    </div>
                    {closeModalError && (
                        <div className="w-full p-2 text-sm text-center text-red-600 bg-red-50 border border-red-200 rounded">
                            {closeModalError}
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <div className={"w-full flex gap-2 justify-end"}>
                        <Button onClick={handleConfirm} actionFeedbackType="save" loadingText="Agendando..." successText="Agendado com sucesso">
                            Confirmar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default JanitorialCreateTaskModal;